<template>
  <div class="navbar">
    <div class="navbar-left">
      <Button icon="pi pi-bars" @click="toggleSidebar" class="p-button-text" />
      <router-link to="/dashboard" class="navbar-item brand">Accestex</router-link>
    </div>
    <div class="navbar-right">
      <span class="user-info">Welcome, {{ username }}</span>
      <Button label="Logout" icon="pi pi-sign-out" @click="logout" class="p-button-text p-button-danger" />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'Navbar',
  components: {
    Button
  },
  props: {
    username: String,
  },
  emits: ['toggle-sidebar'],
  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #ffffff;
  border-bottom: 1px solid #dee2e6;
}
.navbar-left, .navbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.brand {
  font-weight: bold;
  font-size: 1.5rem;
  text-decoration: none;
  color: #333;
}
.user-info {
  font-weight: 500;
}
</style>
